module.exports = __webpack_public_path__ + "media/images/icons/envelope-bbe5c0b608e9c4fd34f8c2dc0d28ef62.png";